import React from 'react';

interface HyperlinkProps {
  onClick: () => void;
  text: string;
  className?: string;
}

function HyperLink({ onClick, text, className }: HyperlinkProps) {
  return (
    <div className={`hyperlink-container ${className}`}>
      <div data-testid="hyperlink-button" onClick={onClick} className="hyperlink-underline">
        <p>{text}</p>
      </div>
    </div>
  );
}

HyperLink.defaultProps = {
  className: '',
};

export { HyperLink };
